// strings/time.ts (M0-T06, §7.1) — weekdays, AM/PM and the clock. Hours reach text only through hourAm/hourPm (rev 6).
import type { StringBank } from '../schema/strings';

export default {
  weekday0: 'Sun', weekday1: 'Mon', weekday2: 'Tue', weekday3: 'Wed', weekday4: 'Thu', weekday5: 'Fri', weekday6: 'Sat',
  am: 'AM', pm: 'PM', clock: '{weekday} {h}:{mm} {ampm}', hourAm: '{h} AM', hourPm: '{h} PM',
} as const satisfies StringBank;
